export default "__VITE_ASSET__uC49e_oe__";